module.exports = __webpack_public_path__ + "static/media/green-D.711a57d7.svg";